<template>
  <div
    v-if="stack.contactIds.length || stack.overflowCount"
    class="ml-auto flex shrink-0 items-center"
    data-test="message-views-avatar-stack"
  >
    <div
      v-for="(contactId, index) in stack.contactIds"
      :key="contactId"
      class="relative size-5 overflow-hidden rounded-full ring-1 ring-white"
      :class="index > 0 ? '-ml-1' : ''"
      :style="{ zIndex: index + 1 }"
    >
      <contact-avatar
        class="views-avatar-stack__avatar"
        :contact="resolveContact(contactId)"
        :contact-type="resolveContact(contactId)?.type"
        :name="resolveName(contactId)"
        :size="24"
      />
    </div>
    <div
      v-if="stack.overflowCount > 0"
      class="
        -ml-1 relative z-10 flex size-5 items-center justify-center
        rounded-full bg-surf-neut-soft-def text-label-m-8-12 text-fg-base-fg14
        ring-1 ring-white
      "
      data-test="message-views-avatar-overflow"
    >
      +{{ stack.overflowCount }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useStoreContacts } from '@/entities/contact'
import { ContactAvatar } from '@/entities/contact-avatar'
import type { MessageViewer } from '@/entities/room'

import { getUnknownContactLabel } from '@/shared/utils/contacts'

import { getViewsAvatarStack } from '../lib/get-views-avatar-stack'

const props = defineProps<{
  viewers: MessageViewer[]
}>()

const { findByPServed } = useStoreContacts()

const stack = computed(() => getViewsAvatarStack(props.viewers))

const resolveContact = (contactId: string) => findByPServed(contactId)

const resolveName = (contactId: string) => {
  const contact = resolveContact(contactId)
  if (contact?.name) return contact.name
  return getUnknownContactLabel(contactId)
}
</script>

<style scoped>
.views-avatar-stack__avatar,
.views-avatar-stack__avatar :deep(.wui-avatar) {
  width: 20px !important;
  height: 20px !important;
  min-width: 20px !important;
  min-height: 20px !important;
}
</style>
